import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { occyLs } from '../../utils/localStorage';
import { createPermissionAwareBaseQuery } from '../../permission-system/middleware/permission-base-query';
import { enablePermissionSafeHooks } from '../../permission-system/middleware/enable-permission-safe-hooks';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/api`,
  // Required for cross-origin cookies (e.g. release-channel canary cookie) to be
  // stored on login and re-sent on subsequent requests, since the app and API
  // live on different subdomains/origins.
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const { token } = getState().auth;
    const delegateAccount = occyLs.getItem('delegated');
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (delegateAccount) {
      headers.set('X-Occy-Id', `${JSON.parse(delegateAccount)}`);
    }
    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery: createPermissionAwareBaseQuery(rawBaseQuery),
  tagTypes: ['Campaign', 'ApplicationAiScore','SlaSettings'],
  endpoints: (builder) => ({}),
});

// Auto-wraps every generated hook (now and via future `injectEndpoints` calls)
// so permission-denied responses centrally resolve loading flags and (when
// registered) substitute a placeholder `data` shape. Must run before any slice
// file destructures hooks from `apiSlice`.
enablePermissionSafeHooks(apiSlice);